<button mat-fab color='primary' class='user-profile-image-cntr'>
  {{ this.userInitial}}
</button>
